import { Component, OnInit } from '@angular/core';
import { PortalService } from 'src/app/service/portal.service';
import { MsisdnService } from 'src/app/service/msisdn.service';
import { SubscriptionService } from 'src/app/service/subscription.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  showModalBox: boolean = false;
  wifiModalBox: boolean = false;
  source: string;
  msisdn: string;
  constructor(
    private portalService: PortalService,
    private msisdnService: MsisdnService,
    private subscriptionService: SubscriptionService,
  ) { }

  async ngOnInit() {
    this.source = sessionStorage.getItem('source') ? sessionStorage.getItem('source') : 'portal';
    //IP
    await this.portalService.getIPAddress();

    this.msisdn = localStorage.getItem('msisdn');

    if (this.msisdn == null || this.msisdn == undefined || this.msisdn == 'NA' || this.msisdn == 'null') {
      //fetch MSISDN
      await this.msisdnService.fetchMSISDN();
    }
    if (this.msisdn == null || this.msisdn == undefined || this.msisdn == 'NA') {
      setTimeout(() => {
        this.wifiModal()
      }, 3000);  //5s
      //CheckSub Scription
      await this.subscriptionService.checkSubscription();
    }

    await this.portalService.visitorLogEntryForPortal();
  }

  wifiModal() {
    this.wifiModalBox = true
  }
  showModal() {
    console.log("click");
    this.showModalBox = true
  }
  closeModal() {
    console.log("click");
    this.wifiModalBox = false
    // this._router.navigateByUrl('/lp')
  }
}
